export enum MyAppointmentsAnalyticsEnum {
  MY_APPOINTMENTS_PAGE_VIEWED = '[PAC WEB] Meus Agendamentos - Página visualizada',
  MY_APPOINTMENTS_GUIDE_DETAILS_VIEWED = '[PAC WEB] Meus Agendamentos - Página de detalhes da guia visualizada',
  MY_APPOINTMENTS_CLICK_REQUEST_CANCEL = '[PAC WEB] Meus Agendamentos - Clicou em Solicitar cancelamento',
  MY_APPOINTMENTS_CANCEL_MODAL_VIEWED = '[PAC WEB] Meus Agendamentos - Modal de cancelamento exibido',
  MY_APPOINTMENTS_CANCEL_FORM_SUBMIT = '[PAC WEB] Meus Agendamentos - Formulário de cancelamento enviado',
  MY_APPOINTMENTS_CANCEL_SUCCESS = '[PAC WEB] Meus Agendamentos - Cancelamento efetuado',
  MY_APPOINTMENTS_CANCEL_ERROR = '[PAC WEB] Meus Agendamentos - Erro ao solicitar cancelamento',
  MY_APPOINTMENTS_RESCHEDULE_SUCCESS = '[PAC WEB] Meus Agendamentos - Reagendamento concluído',
  MY_APPOINTMENTS_CLICK_EXPORT_GUIDE = '[PAC WEB] Meus Agendamentos - Clicou em Exportar guia',
  MY_APPOINTMENTS_CLICK_DOWNLOAD_GUIDE = '[PAC WEB] Meus Agendamentos - Clicou em Baixar guia',
  MY_APPOINTMENTS_CLICK_SHARE_WHATSAPP = '[PAC WEB] Meus Agendamentos - Clicou em Compartilhar por WhatsApp',
  MY_APPOINTMENTS_CLICK_SEND_EMAIL = '[PAC WEB] Meus Agendamentos - Clicou em Enviar por e-mail',
  MY_APPOINTMENTS_SEND_EMAIL_SUCCESS = '[PAC WEB] Meus Agendamentos - Enviou guia por e-mail',
  MY_APPOINTMENTS_CLICK_CHANGE_DATETIME = '[PAC WEB] Meus Agendamentos - Clicou em Alterar data e horário',
  MY_APPOINTMENTS_CLICK_CHANGE_PATIENT = '[PAC WEB] Meus Agendamentos - Clicou em Trocar paciente',
  MY_APPOINTMENTS_CLICK_CANCEL_APPOINTMENT = '[PAC WEB] Meus Agendamentos - Clicou em Cancelar agendamento',
  MY_APPOINTMENTS_CONFIRM_CHANGE_PATIENT = '[PAC WEB] Meus Agendamentos - Confirmou troca de paciente',
  MY_APPOINTMENTS_REVIEW_SUBMITTED = '[PAC WEB] Meus Agendamentos - Enviou avaliação',
  MY_APPOINTMENTS_CLICK_UNCONFIRMED_HELP = '[PAC WEB] Meus Agendamentos - Clicou em Preciso de ajuda em atendimento não confirmado',
}

export enum MyAppointmentsTabAba {
  PROXIMOS = 'proximos',
  HISTORICO = 'historico',
  PENDENTES = 'pendentes',
}

export enum MyAppointmentsDetailsOrigin {
  LISTA = 'lista',
  HOME = 'home',
  CHECKOUT = 'checkout',
  DIRETO = 'direto',
}

export enum MyAppointmentsReviewOrigin {
  EMAIL = 'email',
  PUSH = 'push',
  SITE = 'site',
}

export enum MyAppointmentsAppointmentType {
  PRESENCIAL = 'presencial',
  TELECONSULTA = 'teleconsulta',
}

export enum MyAppointmentsYesNo {
  SIM = 'sim',
  NAO = 'nao',
}

export enum MyAppointmentsCancelErrorType {
  INDISPONIVEL = 'indisponivel',
  SERVIDOR = 'servidor',
}
